export class Tertiary {
  constructor() {
    this.name = "Tertiary";
    this.content = {
      type: "slider",
      numberImages: 4,
      images: []
    };
    this.view = this.viewHtml();
  }

  viewHtml() {
    return `<div>slider</div>`;
  }

  classes() {
    return [
      { property: "PaddingTop", value: "PADDING_TOP_NONE" },
      { property: "PaddingBottom", value: "PADDING_BOTTOM_NONE" }
    ];
  }

  contentClasses() {
    return [
      { property: "Width", value: "WIDTH_FULL"},
      { property: "ObjectFit", value: "COVER"},
    ];
  }

  containerClasses() {
    return []
  }

  containerStyles() {
    return []
  }

  styles() {
    return [];
  }

  elementStyles() {
    return [];
  }

  buttonsClasses() {
    return [];
  }

  buttonsStyles() {
    return [
      {
        property: "BackgroundColor",
        styleProperty: "background-image",
        value: "linear-gradient(0deg, #4319EC, #4319EC)"
      },
      { property: "TextColor", styleProperty: "color", value: "rgba(255,255,255,0.9)" }
    ];
  }

  dotsClasses() {
    return [
      { property: "CarouselDots", value: "DOTS_ROUNDED" },
      { property: "BorderStyle", value: "BORDER_SOLID" },
      { property: "BorderSideTopWidth", value: "BORDER_TOP_THIN" },
      { property: "BorderSideBottomWidth", value: "BORDER_BOTTOM_THIN" },
      { property: "BorderSideLeftWidth", value: "BORDER_LEFT_THIN" },
      { property: "BorderSideRightWidth", value: "BORDER_RIGHT_THIN" }
    ]
  }

  dotsStyles() {
    return [
      { property: "BorderColor", styleProperty: "border-color", value: "#3da4f1" }
    ];
  }

  activeDotStyles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #ffffff,#ffffff)'},
    ]
  }

  itemClasses() {
    return [
      { property: "Display", value: "FLEX" },
      { property: "FlexWrap", value: "FLEX_WRAP" },
      { property: "JustifyContent", value: "JUSTIFY_START" }
    ]
  }

  sliderStyles() {
    return [
      {property:'Height', styleProperty: 'height', value: '400px'}
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view
    };
  }

  editorProperties() {
    return {
      content: this.content,
      buttonsClasses: {
        desktop: this.buttonsClasses(),
        tablet: this.buttonsClasses(),
        phone: this.buttonsClasses()
      },
      buttonsStyles: {
        desktop: this.buttonsStyles(),
        tablet: this.buttonsStyles(),
        phone: this.buttonsStyles()
      },
      styles: {
        phone: this.styles(),
        tablet: this.styles(),
        desktop: this.styles()
      },
      classes: {
        phone: this.classes(),
        tablet: this.classes(),
        desktop: this.classes()
      },
      contentClasses: {
        phone: this.contentClasses(),
        tablet: this.contentClasses(),
        desktop: this.contentClasses()
      },
      containerClasses: {
        desktop: this.containerClasses(),
        tablet: this.containerClasses(),
        phone: this.containerClasses()
      },
      containerStyles: {
        desktop: this.containerStyles(),
        tablet: this.containerStyles(),
        phone: this.containerStyles()
      },
      sliderStyles: {
        desktop: this.sliderStyles(),
        tablet: this.sliderStyles(),
        phone: this.sliderStyles()
      },
      dotsClasses: {
        desktop: this.dotsClasses(),
        tablet: this.dotsClasses(),
        phone: this.dotsClasses()
      },
      dotsStyles: {
        desktop: this.dotsStyles(),
        tablet: this.dotsStyles(),
        phone: this.dotsStyles()
      },
      activeDotStyles: {
        desktop: this.activeDotStyles(),
        tablet: this.activeDotStyles(),
        phone: this.activeDotStyles()
      },
      itemClasses: {
        desktop: this.itemClasses(),
        tablet: this.itemClasses(),
        phone: this.itemClasses()
      }
    };
  }
}
